import { defineMessages } from 'react-intl'

const app = defineMessages({
  'app.text': {
    id: 'app.text',
    description: 'app text description',
    defaultMessage: '文本'
  },
})

const error = defineMessages({
  'app.error.netWork': {
    id: 'app.error.netWork',
    description: '网络错误',
    defaultMessage: 'Network error, please try again later！',
  },
  'app.error.system': {
    id: 'app.error.system',
    description: '系统错误',
    defaultMessage: 'System error, please try it later!',
  },
  'app.error.openUriToastInfo': {
    id: 'app.error.openUriToastInfo',
    defaultMessage: 'Only support Android and iOS system!',
    description: 'open Uri Toast Info',
  },
  'app.error.downloadNotSupport': {
    id: 'app.error.downloadNotSupport',
    defaultMessage: 'Operation System not available yet!',
    description: 'download Not Support',
  },
  'app.error.getCode': {
    id: 'app.error.getCode',
    defaultMessage: 'Please get your code.',
    description: 'get code',
  },
  'app.error.enableAccess': {
    id: 'app.error.enableAccess',
    defaultMessage:
      'Please enable the Contacts Access from the settings menu of your mobile device.',
    description: 'enable the Contacts Access',
  },
  'app.error.noDueAmount': {
    id: 'app.error.noDueAmount',
    defaultMessage: 'Hmm. Currently, you do not have an amount due.',
    description: 'enable the Contacts Access',
  },
  'app.error.failed': {
    id: 'app.error.failed',
    defaultMessage: 'Get auth code failed.',
    description: '获取botim授权失败',
  },
  'app.error.getFailed': {
    id: 'app.error.getFailed',
    defaultMessage: 'Get user info failed.',
    description: '获取用户信息失败',
  },
  'app.error.expired': {
    id: 'app.error.expired',
    defaultMessage:
      'Sorry, The verification information is expired. Please try again later.',
    description: '登录过期',
  },
  'app.error.pleaseSendOTPFirst': {
    id: 'app.error.pleaseSendOTPFirst',
    defaultMessage: 'Please send OTP first.',
    description: '请先发送验证码',
  },
})

const siteConfig = defineMessages({
  'app.siteConfig.Cardsavedsuccessfully': {
    id: 'app.siteConfig.Cardsavedsuccessfully',
    defaultMessage: 'Card saved successfully!',
    description: '绑卡成功提示',
  },
})

export default {
  ...app,
  ...error,
  ...siteConfig,
}
